'use client'
import { useEffect, useState } from 'react'

const useScreenSize = () => {
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const windowResizeEvent = () => {
      // CSS media query와 일치하도록 CSS pixels 기준으로 크기 계산
      let width: number
      let height: number

      // visualViewport API가 지원되는 경우 (모바일에서 더 정확함)
      if (window.visualViewport) {
        width = window.visualViewport.width
        height = window.visualViewport.height
      } else {
        // fallback: document.documentElement.clientWidth/Height 사용
        // 이는 CSS pixels 기준이므로 media query와 일치함
        width = document.documentElement.clientWidth || window.innerWidth
        height = document.documentElement.clientHeight || window.innerHeight
      }

      const size = { width, height }
      setSize(size)

      // if (document && document.documentElement)
      //   document.documentElement.style.setProperty('--vh', `${height / 100}px`)
      // if (document && document.documentElement) {
      //   document.documentElement.style.setProperty('--vh', `${height / 100}px`)
      //   // 실제 화면 높이도 업데이트
      //   document.documentElement.style.setProperty('--svh', `${height}px`)
      // }
    }

    windowResizeEvent()

    window.addEventListener('resize', windowResizeEvent)

    // visualViewport 이벤트도 리스닝 (모바일에서 키보드 등으로 인한 변화 감지)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', windowResizeEvent)
    }

    return () => {
      window.removeEventListener('resize', windowResizeEvent)
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', windowResizeEvent)
      }
    }
  }, [])

  return { ...size }
}

export default useScreenSize
